import React, { useEffect, createElement } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Navbar } from './components/Navbar';
import { Footer } from './components/Footer';
// Pages
import { HomePage } from './pages/HomePage';
import { ServicesPage } from './pages/ServicesPage';
import { ProcessPage } from './pages/ProcessPage';
import { ResultsPage } from './pages/ResultsPage';
import { FAQPage } from './pages/FAQPage';
import { ContactPage } from './pages/ContactPage';
import { CheckoutPage } from './pages/CheckoutPage';
const FAVICON_URL = 'https://cdn.magicpatterns.com/uploads/4Z9hCxF9GbFsHJdtqTcfuJ/Captura_de_pantalla_2026-05-21_a_las_16.06.43.png';
export function App() {
  // Set browser tab title and favicon
  useEffect(() => {
    document.title = 'Growthly LLC';
    const setFavicon = (rel: string) => {
      let link = document.querySelector<HTMLLinkElement>(`link[rel="${rel}"]`);
      if (!link) {
        link = document.createElement('link');
        link.rel = rel;
        document.head.appendChild(link);
      }
      link.type = 'image/png';
      link.href = FAVICON_URL;
    };
    setFavicon('icon');
    setFavicon('shortcut icon');
    setFavicon('apple-touch-icon');
  }, []);
  return <Router data-id="element-0">
      <div className="min-h-screen bg-[#0a0a0a] font-sans text-gray-100 selection:bg-emerald-500/30" data-id="element-1">
        <Navbar data-id="element-2" />
        <main className="overflow-hidden" data-id="element-3">
          <Routes data-id="element-4">
            <Route path="/" element={<HomePage data-id="element-6" />} data-id="element-5" />
            <Route path="/servicios" element={<ServicesPage data-id="element-8" />} data-id="element-7" />
            <Route path="/proceso" element={<ProcessPage data-id="element-10" />} data-id="element-9" />
            <Route path="/resultados" element={<ResultsPage data-id="element-12" />} data-id="element-11" />
            <Route path="/faq" element={<FAQPage data-id="element-14" />} data-id="element-13" />
            <Route path="/contacto" element={<ContactPage data-id="element-16" />} data-id="element-15" />
            <Route path="/checkout" element={<CheckoutPage data-id="element-18" />} data-id="element-17" />
          </Routes>
        </main>
        <Footer data-id="element-19" />
      </div>
    </Router>;
}